/* Multiple Entry Styling */
.entry {
    width: 100%;
}

.fieldDescription {
    composes: fieldDescription from './common.module.css';
}